import {
  REACT_APP_CLIENT_NAME,
} from 'config';

export const COPYRIGHT = `© ${REACT_APP_CLIENT_NAME} ${new Date().getFullYear()}. All Rights Reserved.`;
